module.exports = __webpack_public_path__ + "static/media/Sharrie.17d1d4bf.png";